import React, { useState } from "react";
import { Button, FormGroup, FormControl, FormLabel, Alert, Row, Col } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import validator from "validator"
import { useEffect } from "react";
import { getFromStorage } from "../../../utils/storage";

const color = "#229a88";

function PatientProfile(props) {
  const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [retypePassword, setRetypePassword] = useState("");
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [number, setNumber] = useState("");
  const [address, setAddress] = useState("");
  
  function validateForm() {
    return name.length > 0 && age.length > 0 && gender.length > 0 && email.length > 0  && number.length > 0;
  }

  function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);

    if (!validator.isEmail(email)){
        setErrors(["Email not valid"]);
        setSuccess("");
        setIsSubmitting(false);
    } else {
        // signup();
        setSuccess("");
        setIsSubmitting(false);
    }
  }

  useEffect(() => {
    setName(getFromStorage("data").name.toString());
    setEmail(getFromStorage("data").email.toString());
    setAge(getFromStorage("data").age.toString());
    setNumber(getFromStorage("data").phone.toString());
    setGender(getFromStorage("data").gender.toString());
  }, [])

//   const signup = () => {
//     const body = {task: "registerPatient", name, age, gender, email, phone: number, address, password}
//     const headers = {"Content-Type": "application/json"}
//     axios.post(Api.PatientApi, body, headers)
//     .then(res => {
//         if(res.data === 200){
//             setName("");
//             setAge("");
//             setGender("")
//             setEmail("")
//             setPassword("")
//             setRetypePassword("")
//             setNumber("")
//             setAddress("")
//             setIsSubmitting(false)
//             setSuccess("Successfully Signed Up You can now log in")
//             setErrors([])
//         } else {
//             setErrors(["Error! Couldn't Signup"])
//             setSuccess("")
//             setIsSubmitting(false)
//         }
//     })
//     .catch(err => { 
//         setErrors(["Something went wrong"])
//         setSuccess("")
//         setIsSubmitting(false)
//     })
//  }

  return (
        <div style={{overflow: "auto"}}>
            <form onSubmit={handleSubmit}>
                {
                    errors.map((error,i) =>
                        <Alert key={i} variant="danger" style={{fontSize: "12px"}}>
                            {error}
                        </Alert>
                    )
                }
                {
                    success.length > 0 && 
                    <Alert variant="success" style={{fontSize: "12px"}}>
                        {success}
                    </Alert>
                }
                <FormGroup controlId="name" bssize="large" style={{textAlign: "left"}}>
                    <FormLabel>Name<span style={{color: "red"}}>*</span></FormLabel>
                    <FormControl
                        type="text"
                        placeholder="Name"
                        value={name}
                        size="sm"
                        onChange={e => {
                            setName(e.target.value);
                            setSuccess("");
                            setErrors([]);
                        }}
                    />
                </FormGroup>
                <FormGroup controlId="age" bssize="large" style={{textAlign: "left"}}>
                    <FormLabel>Age<span style={{color: "red"}}>*</span></FormLabel>
                    <FormControl
                        type="text"
                        placeholder="Age"
                        value={age}
                        pattern="[0-9]*"
                        size="sm"
                        onChange={e => {
                            if(e.target.validity.valid){
                                setAge(e.target.value);
                                setSuccess("");
                                setErrors([]);
                            }
                        }}
                    />
                </FormGroup>
                <FormGroup controlId="gender" bssize="large" style={{textAlign: "left"}}>
                    <FormLabel>Gender<span style={{color: "red"}}>*</span></FormLabel>
                    <FormControl
                        as="select"
                        value={gender}
                        size="sm"
                        onChange={e => {
                            setGender(e.target.value);
                            setSuccess("");
                            setErrors([]);
                        }}
                    >
                        <option style={{color: "silver"}} value="">Select Gender</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                    </FormControl>
                </FormGroup>
                
                <FormGroup controlId="email" bssize="large" style={{textAlign: "left"}}>
                    <FormLabel>Email<span style={{color: "red"}}>*</span></FormLabel>
                    <FormControl
                        type="email"
                        placeholder="Email"
                        value={email}
                        size="sm"
                        onChange={e => {
                            setEmail(e.target.value);
                            setSuccess("");
                            setErrors([]);
                        }}
                    />
                </FormGroup>
                <FormGroup controlId="address" bssize="large" style={{textAlign: "left"}}>
                    <FormLabel>Address</FormLabel>
                    <FormControl
                        type="text"
                        placeholder="Address"
                        value={address}
                        size="sm"
                        onChange={e => {
                            setAddress(e.target.value);
                            setSuccess("");
                            setErrors([]);
                        }}
                    />
                </FormGroup>
                <FormGroup controlId="phone_number" bssize="large" style={{textAlign: "left"}}>
                    <FormLabel>Phone Number<span style={{color: "red"}}>*</span></FormLabel>
                    <FormControl
                        type="text"
                        placeholder="Phone Number"
                        value={number}
                        size="sm"
                        pattern="[0-9]*"
                        onChange={e => {
                            if(e.target.validity.valid){
                                setNumber(e.target.value);
                                setSuccess("");
                                setErrors([]);
                            }
                        }}
                    />
                </FormGroup>
                <div style={{textAlign: "center"}}>
                    <Button size="sm" disabled={!validateForm() || isSubmitting ? true:false} type="submit" style={{background: color, borderColor: color, width: "auto", marginLeft: "auto", marginRight: "auto"}} variant="dark">
                        {!isSubmitting ? "Update Profile" : "Loading..."}
                    </Button>
                </div>
            </form>
      </div>
  );
}

export default withRouter(PatientProfile);